if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');      
      this.submitButton = this.querySelector('[type="submit"]');
      this.variantSelector = this.form.querySelector('[name=id]'); // Variant selector

      this.variantSelector.disabled = false;
      
      this.variantSelector.addEventListener('change', this.onVariantChange.bind(this));

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.disabled = true;
    }

    onVariantChange() {
      const variantId = this.variantSelector.value;
      
      if (variantId && variantId !== 'null') {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.disabled = false;
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.disabled = true;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const variantId = this.variantSelector.value;
      if (!variantId || variantId === 'null') {
        this.handleErrorMessage('Please select a variant.');
        return;
      }

      this.handleErrorMessage();
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('id', variantId);  // Ensure variant ID is added to form data

      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            this.submitButton.querySelector('.sold-out-message').classList.remove('hidden');
            return;
          }

          this.cart.renderContents(response);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
